// ./build.sh homebaseVideoList

import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import Common from './components/ynadmin/common/common.js';
import videoPlayer from './components/common/videoPlayerOne.vue';
import mobile from 'is-mobile';
import swal from "sweetalert";

Vue.use(mobile);

Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component('videoplayer', videoPlayer);

Vue.prototype.$pager = Pager;

new Vue({
    el: '#homebase',
    data: function () {
        return {
            mainName: '홈베이스',
            isMobile: false,
            listBanner: [],
            searchModel: {
                startDate: '',
                endDate: '',
                subStartDate: '',
                subEndDate: '',
                searchKword: '',
                searchOrder: '',
                searchOption: '',
                searchSubject: '',
                searchCode: '',
                searchPage: 10,
                delYn: ''
            },
            isMobileStyle: {
                'width': '100%',
                //'height' : '250px'
                'height': 'auto'
            },
            isMobileStyles: {
                'height': 'auto'
            },
            basicOptions: {
                playerOptions: [{
                    height: '360',
                    autoplay: true,
                    muted: true,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        // mp4
                        src: "",
                        // webm
                        // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                    }],
                    poster: ""
                }]
            },
            viewModel: {
                myPager: {
                    model: {},
                    pageNo: 1,
                    pageNum: 1,
                    totalSize: 0,
                    rowSize: 10,
                    blockSize: 5,
                    endSize: 0,
                    list: [],
                    href: "javascript:void(0)",
                    etc: '',
                    callBack: function (n) {
                        let _etc = this.model.viewModel.myPager.etc;
                        if (_etc == 'selectRsrvFestivalList') {
                            this.model.fnGetRsrvFestivalList(n);
                        } else if (_etc == 'selectNoticeList') {
                            this.model.fnGetMyNoticeList(n);
                        } else if (_etc == 'selectMyCancleList') {
                            this.model.fnGetMyHomeBaseCancleList(n);
                        }
                    }
                },
                onePager: { //한줄에 1개 페이징
                    model: {},
                    pageNo: 1,
                    pageNum: 1,
                    totalSize: 0,
                    rowSize: 2,
                    blockSize: 5,
                    endSize: 0,
                    list: [],
                    href: "javascript:void(0)",
                    class: 'paging_purple',
                    etc: '',
                    callBack: function (n) {
                        let _etc = this.model.viewModel.onePager.etc;
                        if (_etc == 'selectNoticeList') {
                            this.model.fnGetNoticeList(n);
                        } else if (_etc == 'selectMyHomeBaseList') {
                            this.model.fnGetMyHomeBaseList(this.model.searchModel.delYn, n);
                        } else if (_etc == 'selectGalleryList') {
                            this.model.fnGetGalleryList(this.model.searchModel.searchCode, this.model.searchModel.searchOrder, n);
                        }
                    }
                },
                oneSubPager: { //한줄에 1개 보조 페이징
                    model: {},
                    pageNo: 1,
                    pageNum: 1,
                    totalSize: 0,
                    rowSize: 2,
                    blockSize: 5,
                    endSize: 0,
                    list: [],
                    href: "javascript:void(0)",
                    class: 'paging_purple',
                    etc: '',
                    callBack: function (n) {
                        let _etc = this.model.viewModel.oneSubPager.etc;
                        if (_etc == 'selectMyRegHomeBaseList') {
                            this.model.fnGetMyRegHomeBaseList(null, n);
                        }
                    }
                },
                twoPager: { //한줄에 2개 페이징 - 커뮤니티 / 60초챌린지
                    model: {},
                    pageNo: 1,
                    pageNum: 1,
                    totalSize: 0,
                    rowSize: 4,
                    blockSize: 5,
                    endSize: 0,
                    list: [],
                    href: "javascript:void(0)",
                    class: 'paging_purple',
                    etc: '',
                    callBack: function (n) {
                        let _etc = this.model.viewModel.twoPager.etc;
                        if (_etc == 'selectCommunityList') {
                            this.model.fnGetCommunityList(n);
                        } else if (_etc == 'selectChallengeList') {
                            this.model.fnGetChallengeList(null, n);
                        }
                    }
                },
                threePager: { //한줄에 3개 페이징
                    model: {},
                    pageNo: 1,
                    pageNum: 1,
                    totalSize: 0,
                    rowSize: 6,
                    blockSize: 5,
                    endSize: 0,
                    list: [],
                    href: "javascript:void(0)",
                    class: 'paging_purple',
                    etc: '',
                    callBack: function (n) {
                        let _etc = this.model.viewModel.threePager.etc;
                        if (_etc == 'selectHomeBaseList') {
                            this.model.fnGetHomeBaseList(this.model.searchModel.searchSubject, n);
                        } else if (_etc == 'selectFestivalList') {
                            this.model.fnGetFestivalList(n);
                        } else if (_etc == 'selectContentsList') {
                            this.model.fnGetContentsList(n);
                        }
                    }
                },
                threeSubPager: { //한줄에 3개 보조 페이징
                    model: {},
                    pageNo: 1,
                    pageNum: 1,
                    totalSize: 0,
                    rowSize: 6,
                    blockSize: 5,
                    endSize: 0,
                    list: [],
                    href: "javascript:void(0)",
                    class: 'paging_purple',
                    etc: '',
                    callBack: function (n) {
                        let _etc = this.model.viewModel.threeSubPager.etc;
                        if (_etc == 'selectFestivalList') {
                            this.model.fnGetMyFestivalList(n);
                        }
                    }
                },
                isHbIntroTab: true,
                isHbContentsTab: false,
                isHbCommunityTab: false,
                isHbMemberTab: false,
                isWrite: true,
                isWriteComplete: false,
                isCntntMember: false,
                isSurveyEnd: false,
                isReply: false,
                isReplyUpt: false,
                isReReply: false,
                isReReplyUpt: false,
                isBadge: false,
                isLike: false,
                isZzim: false,
                isReport: false,
                agree1: false,
                agree2: false,
                regUsrYn: '',
                zzimYn: '',
                currReplyUidKey: '',
                weekStartDate: '',
                weekEndDate: '',
                surveyTotCnt: 0,
                totalCount: 1,
                totalCountWeekly: 1,
                totalCountGallery: 1,
                totalCountchallenge: 1,
                badgeCount: 0,
                insertBadgeCount: 0,
                detail: {},
                userDetail: {},
                typeCodeList: [],
                targetCodeList: [],
                subjectCodeList: [],
                memberCodeList: [],
                scopeCodeList: [],
                communityCodeList: [],
                authCodeList: [],
                homeBaseList: [],
                myHomeBaseList: [],
                myRegHomeBaseList: [],
                memberList: [],
                usrKeyList: [],
                memberStrNameList: [],
                contentsList: [],
                contentsImgList: [],
                replyList: [],
                replyDepthZero: [],
                replyDepthOne: [],
                communityList: [],
                surveyList: [],
                surveyVoteList: [],
                regBoardList: [],
                galleryList: [],
                gallerySubjectCodeList: [],
                weeklyHotList: [],
                weeklyHotKeyList: [],
                reportCodeList: [],
                reportList: [],
                noticeList: [],
                challengeList: [],
                challengeImgList: [],
                challengeHotList: [],
                challengeHotImgList: [],
                memberAuthList: [],
                updateAuthList: [],
                festivalList: [],
                myFestivalList: [],
                hourList: [],
                minuteList: [],
                fileEtcList: [],
                fileImgList: [],
                fileVdList: [],
                naviMentoList: [] // 내비쌤 목록
            }
        }
    },
    created: function () {
        this.isMobile = mobile();
        if (!('$' in Vue.prototype) && '$' in window) {
            Vue.prototype.$ = window.$;
        }
    },
    mounted: function () {
        try {
            if ($("#pageName").val() == "homeBaseMain") {
                $(".mainName").text("");
                $(".btn_back").hide();
            } else {
                //메인헤더에 문구 추가
                $(".mainName").before('<span class="page_tit_sm">청소년 </span>');
            }

            this.$nextTick(function () {
                pageLoad(this);
                this.fnOnCheckBanner();
            });
        } catch (e) {
            console.log(e);
        }
    },
    watch: {
        selectHbModelType: function (newValue, oldValue) {
            this.inputLabel = (newValue != '') ? newValue.codeName : '';
        },
        selectHbModelMemberType: function (newValue, oldValue) {
            this.memberLabel = (newValue != '') ? newValue.codeName : '';
            this.viewModel.isCntntMember = true;
        },
        selectHbModelScopeType: function (newValue, oldValue) {
            this.scopeLabel = (newValue != '') ? newValue.codeName : '';
        },
        selectHbModelGalleryType: function (newValue, oldValue) {
            this.typeLabel = (newValue != '') ? newValue.codeName : '';
        }
    },
    methods: {

        fnGoHomeBaseMain: function (tabCate) { //홈베이스 메인페이지
            location.href = '/customer/homebase';
        },
        fnOnCheckBanner: function () {
            let vm = this;
            let _param = {
                uidKey: 'BANNVLOCNV00400',
                divide: 'custommer'
            }
            let param = {
                pageNo: 0,
                pageSize: 10,
                paramText: JSON.stringify(_param)
            };

            Axios.post("/api/admin/banner/list", param).then(function (response) {
                vm.listBanner = response.data.list;

                /*   $(".banner_yard a").css("background-image", "url("+response.data.list[0].imagePath + ")"); */
            }).catch(function (ex) {
                console.log(ex);
            });
        },
        fnGoHomeBaseInsertMain: function () { //동아리 개설 페이지
            //if($("#smlCode").val() == "USRNVYTHNV00110" || $("#smlCode").val() == "USRNVYTHNV00123" || $("#smlCode").val() == "USRNVYTHNV00124"){
            if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
                swal("로그인 후 이용해주세요.").then(result => {
                    location.href = '/youthnavi/signup/login';
                });
                return false;
            } else {
                let smlCd = $("#smlCode").val();
                // ---------- 청소년 ----------------------- 인플루언서 -------------- 진로동기부여 홈베갤러리 내비쌤 ------ 교사 --------------------------- 청소년지도자
                if (smlCd === "USRNVYTHNV00110" || smlCd === "USRNVYTHNV00123" || smlCd === "USRNVYTHNV00124" || smlCd === 'USRNVYTHNV00125' || smlCd === 'USRNVYTHNV00212') {
                    location.href = '/customer/homebase/homeBaseInsertMain';
                } else {
                    swal("동아리는 청소년, 인플루언서, 교사, 진로동기멘토, 청소년지도자만 개설이 가능합니다.");
                    return false;
                }
            }
        },
        fnGoHomeBaseUpdateMain: function (uid) { //동아리 관리 페이지
            location.href = '/customer/homebase/homeBaseUpdateMain?paramUid=' + uid;
        },
        fnGoHomeBaseDetail: function (uid) { //동아리 상세 페이지
            location.href = '/customer/homebase/homeBaseDetail?paramUid=' + uid;
        },
        fnGoHomeBaseDetailSub: function (uid) {
            let pageNum = this.viewModel.threePager.pageNo;

            if (this.searchModel.searchSubject == undefined || this.searchModel.searchSubject == null || this.searchModel.searchSubject == "") {

                sessionStorage.setItem("URL", "/customer/homebase?tabIdx=joinclub&searchSubject=" + "all" + "&pageNum=" + pageNum);

                location.href = '/customer/homebase/homeBaseDetail?paramUid=' + uid + "&searchSubject=all";
            } else {

                sessionStorage.setItem("URL", "/customer/homebase?tabIdx=joinclub&searchSubject=" + this.searchModel.searchSubject + "&pageNum=" + pageNum);

                location.href = '/customer/homebase/homeBaseDetail?paramUid=' + uid + "&searchSubject=" + this.searchModel.searchSubject;
            }

        },
        fnGoContentsInsertMain: function (uid, parentsUid) { //동아리 컨텐츠 업로드 페이지
            if (parentsUid === undefined) parentsUid = "";
            location.href = '/customer/homebase/contentsInsertMain?paramUid=' + uid + "&parentsUid=" + parentsUid;
        },
        fnGoLogin: function () {
            swal({
                text: "로그인이 필요한 기능입니다.\n로그인하시겠습니까?",
                closeOnClickOutside: false,
                icon: fnOnLoadSwalImageData("info"),
                buttons: {
                    confirm: {
                        text: "확인",
                        value: true,
                        visible: true
                    },
                    cancel: {
                        text: "취소",
                        value: false,
                        visible: true
                    }
                }
            }).then(result => {
                if (result) {
                    location.href = "/youthnavi/signup/login";
                } else {
                    return false;
                }
            });
        },

        fnGoContentsDetail: function (uid) { //동아리 컨텐츠 상세 페이지

            let pageName = $("#pageName").val();

            if (pageName == "challengeMain") {
                let pageNum = this.viewModel.twoPager.pageNo;
                sessionStorage.setItem("URL", "/customer/homebase/challengeMain?pageNum=" + pageNum);
            }


            location.href = '/customer/homebase/contentsDetail?paramUid=' + uid;
        },
        fnGoCommunityInsertMain: function (uid, flag) { //동아리 커뮤니티 등록/수정 페이지
            location.href = '/customer/homebase/communityInsertMain?paramUid=' + uid + "&paramFlag=" + flag;
        },
        fnGoCommunityDetail: function (uid) { //동아리 커뮤니티 상세 페이지
            location.href = '/customer/homebase/communityDetail?paramUid=' + uid;
        },
        fnGoCommunitySurvey: function (uid) { //동아리 커뮤니티 투표 페이지
            location.href = '/customer/homebase/communitySurvey?paramUid=' + uid;
        },
        fnGoGalleryMain: function () { //홈베갤러리 페이지
            location.href = '/customer/homebase/galleryMain';
        },
        fnGoNaviMentoMain: function () { //홈베내비샘 페이지
            location.href = '/customer/homebase/naviMentoMain';
        },
        fnGoGalleryInsertMain: function (uid) { //홈베갤러리 개설 페이지
            location.href = '/customer/homebase/galleryInsertMain?paramUid=' + uid;
        },
        fnGoGalleryDetail: function (uid) { //홈베갤러리 상세 페이지
            location.href = '/customer/homebase/galleryDetail?paramUid=' + uid;
        },
        fnGoWeeklyHotContentsMain: function () { //주간 HOT 페이지
            location.href = '/customer/homebase/weeklyHotContentsMain';
        },
        fnGoNoticeMain: function () { //공지사항 페이지
            location.href = '/customer/homebase/noticeMain';
        },
        fnGoNoticeDetail: function (uid) { //공지사항 상세 페이지
            location.href = '/customer/homebase/noticeDetail?paramUid=' + uid;
        },
        fnGoChallengeMain: function () { //60초 챌린지 페이지
            location.href = '/customer/homebase/challengeMain';
        },
        fnGoChallengeInsertMain: function (uid) { //60초 챌린지 업로드 페이지
            if (uid === undefined) uid = "";
            location.href = '/customer/homebase/contentsInsertMain?paramUid=' + uid;
        },
        fnGoLiveFestivalMain: function () { //Live 축제 페이지
            location.href = '/customer/homebase/liveFestivalMain';
        },
        fnGoLiveFestivalVodMain: function () { //Live 축제 다시보기 페이지
            location.href = '/customer/homebase/liveFestivalVodMain';
        },
        fnGoMyHomeBaseMain: function () { //동아리 - 홈베이스 동아리 관리 페이지
            if ($("#grpCode").val() == "USRNVYTHNV00100") { //사용자
                location.href = '/youthnavi/mypage/user/myHomeBaseMain';
            } else if ($("#grpCode").val() == "USRNVYTHNV00200") { //기관
                location.href = '/youthnavi/mypage/center/myHomeBaseMain';
            }
        },
        fnGoMyLiveFestivalInsertMain: function (uid) { //마이내비 - Live 축제 예약하기 페이지
            if (uid === undefined) uid = "";
            location.href = '/youthnavi/mypage/center/myLiveFestivalInsertMain?paramUid=' + uid;
        },
        fnGoMyNoticeInsertMain: function (uid) { //마이내비 - 공지사항 작성 페이지
            if (uid === undefined) uid = "";
            location.href = '/youthnavi/mypage/center/myNoticeInsertMain?paramUid=' + uid;
        },

        /*============================================================ 조회 start ========================================================================*/
        //동아리 계열 / 홈베갤러리 계열 코드 조회
        fnGetSubjectCodeList: function () {
            let vm = this;
            let param = {
                searchGroupCode: "AFLNVADMNV000000", //계열의 대분류코드값 (이게 없으면 계열 상세 코드도 조회됨)
                searchCode: "AFLNVADMNV" //계열
            };
            Axios.post("/customer/homebase/selectCodeList", {homeBaseVo: param}).then(function (response) {
                //같이 담으면 subjectCodeList에도 자유갤러리 추가됨. forEach로 분리함.
                vm.viewModel.subjectCodeList = response.data.list;

                let gallerySubjectCodeList = [];
                vm.viewModel.subjectCodeList.forEach(function (item) {
                    gallerySubjectCodeList.push(item);
                });
                gallerySubjectCodeList.push({codeValue: 'HBGALLSBJCTNV000100', codeName: '자유갤러리'});
                vm.viewModel.gallerySubjectCodeList = gallerySubjectCodeList;
            }).catch(function (ex) {
                console.log(ex);
            });
        },
        //동아리 리스트 조회
        fnGetHomeBaseList: function (searchSubject, pageNumber) {
            let vm = this;
            vm.viewModel.threePager.pageNo = pageNumber ? pageNumber : 1;

            vm.searchModel.searchSubject = searchSubject;

            let param = {};
            param.searchSubject = vm.searchModel.searchSubject;
            param.pageNo = vm.viewModel.threePager.pageNo;
            param.pageSize = vm.viewModel.threePager.rowSize;

            Axios.post("/customer/homebase/selectHomeBaseList", {homeBaseVo: param}).then(function (response) {
                vm.viewModel.totalCount = response.data.totalCount;
                vm.viewModel.homeBaseList = response.data.list;
                vm.viewModel.homeBaseList.forEach(function (homebase) {
                    if (homebase.recruitYn == 'Y') {
                        homebase.recruitName = "모집";
                    } else if (homebase.recruitYn == 'N') {
                        homebase.recruitName = "마감";
                    }
                });
                vm.fnSetPager(vm.viewModel.totalCount, "selectHomeBaseList", vm.viewModel.threePager);
                //console.log("homeBaseList",vm.viewModel.homeBaseList);
            }).catch(function (ex) {
                console.log(ex);
            });
        },
        //홈베이스 메인 - 내 개설 동아리 리스트 조회
        fnGetMyMainHomeBaseList: function () {
            let vm = this;
            let param = {};
            param.usrKey = $("#usrKey").val();
            param.delYn = "N";
            param.approve = "approve";
            param.pageNo = 1;
            param.pageSize = 100;

            Axios.post("/customer/homebase/selectMyHomeBaseList", {homeBaseVo: param}).then(function (response) {
                vm.viewModel.myHomeBaseList = response.data.list;
            }).catch(function (ex) {
                console.log(ex);
            });
        },
        //홈베이스 메인 - 내 가입 동아리 리스트 조회
        fnGetMyMainRegHomeBaseList: function (aprv) {
            let vm = this;

            let param = {};
            param.usrKey = $("#usrKey").val();
            param.approve = aprv ? aprv : null
            param.pageNo = vm.viewModel.oneSubPager.pageNo;
            param.pageSize = vm.viewModel.oneSubPager.rowSize;

            Axios.post("/customer/homebase/selectMyRegHomeBaseList", {homeBaseVo: param}).then(function (response) {
                vm.viewModel.myRegHomeBaseList = response.data.list;
            }).catch(function (ex) {
                console.log(ex);
            });
        },
        //메인페이지 홈베갤러리 리스트
        fnGetMainGalleryList: function (order) {
            let vm = this;
            let param = {};

            // 관리자가 설정한 게시글을 조회
            param.loc = 'homebase_gallely';
            Axios.post("/customer/homebase/selectMainDpGalleryList", {displayItemDTO: param}).then(function (response) {
                vm.viewModel.totalCountGallery = response.data.list.length;
                vm.viewModel.galleryList = response.data.list;
            }).catch(function (ex) {
                console.log(ex);
            });

            // 최신순 조회
            // param.searchOrder = order ? order : "insertDate";
            // Axios.post("/customer/homebase/selectMainGalleryList", {homeBaseVo:param}).then(function(response) {
            //     vm.viewModel.totalCountGallery = response.data.list.length;
            //     vm.viewModel.galleryList = response.data.list;
            // }).catch(function(ex) {
            //     console.log(ex);
            // });
        },
        //주간 HOT 리스트
        fnGetMainWeeklyHotList: function (searchOrder) {
            let vm = this;

            let param = {};
            param.searchOrder = searchOrder;
            // param.searchOption = "weekly"; // 해당 옵션 사용 시, 최근 2주의 컨텐츠만 조회함
            param.pageNo = 1;
            param.pageSize = 3;

            Axios.post("/customer/homebase/selectContentsList", {homeBaseVo: param}).then(function (response) {
                let _list = response.data.list;
                let _img = response.data.fileImgList;
                // 2022.11.09 썸네일 이미지 경로를 쿼리에서 만들어오는 것으로 수정하여 아래소스는 주석처리 함. (.img 대신 .fileLink 를 사용해야함)
                // if(_img != null){
                //     _img.forEach(function(item, idx){
                //         if(item != null){
                //             item.img = '/video/' +  item.file_new_name.substring(0,8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
                //         }
                //     });
                // }
                vm.viewModel.totalCountWeekly = response.data.totalCount;
                vm.viewModel.weeklyHotList = _list;
                vm.viewModel.contentsImgList = _img;
                console.log("weeklyHotList", vm.viewModel.weeklyHotList);
                console.log("totalCountWeekly", vm.viewModel.totalCountWeekly);
            }).catch(function (ex) {
                console.log(ex);
            });
        },
        //홈베이스 60초 챌린지 리스트
        fnGetChallengeList: function (searchOrder, pageNumber) {
            let vm = this;
            vm.viewModel.twoPager.pageNo = pageNumber ? pageNumber : 1;

            let param = {};
            if (searchOrder == "main") {
                param.pageNo = 1;
                param.pageSize = 3;
            } else if (searchOrder == "hit") {
                param.pageNo = 1;
                param.pageSize = 5;
                param.searchOrder = searchOrder;
            } else {
                vm.viewModel.twoPager.rowSize = 6;
                param.pageNo = vm.viewModel.twoPager.pageNo;
                param.pageSize = vm.viewModel.twoPager.rowSize;
            }

            Axios.post("/customer/homebase/selectChallengeList", {homeBaseVo: param}).then(function (response) {
                let _list = response.data.list;
                let _img = response.data.fileImgList;

                if (_list != null) {
                    _list.forEach(function (item) {
                        item.checked = false;
                    });
                }
                if (_img != null) {
                    _img.forEach(function (item, idx) {
                        if (item != null) {
                            item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
                            // item.video = "http://152.70.237.207:8080/video/" +item.file_new_name.substring(0,8) + "/" + item.file_new_name.split(".")[0] + '.mp4' ;
                            item.video = "/video/" + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.mp4';
                        }
                    });
                }

                if (searchOrder == "main" || searchOrder == "hit") {
                    vm.viewModel.totalCountchallenge = _list.length;
                    vm.viewModel.challengeHotList = _list;
                    vm.viewModel.challengeHotImgList = _img;
                } else {
                    vm.viewModel.totalCount = response.data.totalCount;
                    vm.viewModel.challengeList = _list;
                    vm.viewModel.challengeImgList = _img;
                    vm.fnSetPager(vm.viewModel.totalCount, "selectChallengeList", vm.viewModel.twoPager);
                }
                //console.log("challengeList",vm.viewModel);
            }).catch(function (ex) {
                console.log(ex);
            });
        },
        fnOnChangeMouseOver: function (item) {
            item.checked = true;
        },
        fnOnChangeMouseLeave: function (item) {
            item.checked = false;
        },
        //페이징 처리
        fnSetPager: function (totalCount, etc, paramPager) {
            let vm = this;
            paramPager.etc = etc;
            paramPager.totalSize = totalCount;
            paramPager.pageNum = (paramPager.pageNo * paramPager.rowSize) - paramPager.rowSize;
            Pager.props = Pager.methods.createPager(paramPager, vm, "list");
        },

        //////////////////////////////////////////////////////////////////////
        tabSlide: function () {
            var tabSwiper = new Swiper('.hb_tab_container', {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: false,
                speed: 500,
                mousewheel: {
                    invert: false,
                },
                preventClicksPropagation: false,
                observer: true,
                observeParents: true
            });
        },
        //탭슬라이드 가운데로 위치(스타일함수)
        tabFocus: function (item) {
            let vm = this;
            var target = $("#" + item);
            vm.muCenter(target);
        },
        muCenter: function (target) {
            var snbwrap = $('.hb_tab_container .swiper-wrapper');
            var targetPos = target.position();
            var box = $('.hb_tab_container');
            var boxHarf = box.width() / 2;
            var pos;
            var listWidth = 0;

            snbwrap.find('.swiper-slide').each(function () {
                listWidth += $(this).outerWidth();
            })

            var selectTargetPos = targetPos.left + target.outerWidth() / 2;
            if (selectTargetPos <= boxHarf) { // left
                pos = 0;
            } else if ((listWidth - selectTargetPos) <= boxHarf) { //right
                pos = listWidth - box.width();
            } else {
                pos = selectTargetPos - boxHarf;
            }

            setTimeout(function () {
                snbwrap.css({
                    "transform": "translate3d(" + (pos * -1) + "px, 0, 0)",
                    "transition-duration": "500ms"
                })
            }, 200);
        },
        fnGetNaviMentoList(subjectStr) { // 내비쌤 목록 조회
            let vm = this;
            const param = {lineList: subjectStr === '' ? [] : [subjectStr]}
            Axios.post("/api/expinfo/naviMentoList", param).then(function (response) {
                vm.viewModel.naviMentoList = response.data.naviMenoList;
            })
        },
        fnGoNaviMentoDetail(uid) { // 내비쌤 상세로 이동
            location.href = "/customer/homebase/naviMentoDetail?uidKey=" + uid;
        },
        fnOutGunLabel: function (val) { // 내비쌤 구분명 출력
            if (val == '1') return '대학생'
            if (val == '2') return '교수'
            if (val == '3') return '전문가'
        }
    }
});
